import { SecurityCheckIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Head } from "@inertiajs/react";
import Dashboard from "@/components/dashboard";
import { Badge } from "@/components/ui/badge";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import type EventsEvent from "@/types/serializers/EventsEvent";
import type HomeUser from "@/types/serializers/HomeUser";

interface Props {
	user: HomeUser;
	events: EventsEvent[];
}

const ACTION_LABELS: Record<string, string> = {
	signed_in: "Přihlášení",
	signed_out: "Odhlášení",
	password_changed: "Změna hesla",
	email_changed: "Změna e-mailu",
	email_verified: "Ověření e-mailu",
};

const ACTION_VARIANTS: Record<string, "default" | "secondary" | "outline"> = {
	signed_in: "default",
	signed_out: "secondary",
	password_changed: "outline",
	email_changed: "outline",
	email_verified: "default",
};

export default function Index({ user, events }: Props) {
	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleString("cs-CZ", {
			day: "numeric",
			month: "long",
			year: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		});
	};

	return (
		<>
			<Head title="Bezpečnostní události" />
			<Dashboard user={user}>
				<div className="flex flex-1 flex-col gap-6 p-4 lg:p-6">
					<div className="flex items-center gap-3">
						<div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
							<HugeiconsIcon
								icon={SecurityCheckIcon}
								strokeWidth={2}
								className="size-5 text-primary"
							/>
						</div>
						<div>
							<h2 className="font-semibold text-2xl">Bezpečnostní události</h2>
							<p className="text-muted-foreground text-sm">
								Historie bezpečnostních událostí vašeho účtu
							</p>
						</div>
					</div>

					<Card>
						<CardHeader>
							<CardTitle>Historie aktivit</CardTitle>
							<CardDescription>
								Zde vidíte všechny bezpečnostní události spojené s vaším účtem.
							</CardDescription>
						</CardHeader>
						<CardContent className="space-y-4">
							{events.map((event) => (
								<div
									key={event.id}
									className="flex items-center justify-between gap-4 rounded-lg border p-4"
								>
									<div className="flex flex-col gap-1">
										<div className="flex items-center gap-2">
											<Badge
												variant={ACTION_VARIANTS[event.action] || "outline"}
											>
												{ACTION_LABELS[event.action] || event.action}
											</Badge>
										</div>
										<div className="text-muted-foreground text-xs">
											<span>IP: {event.ip_address || "Neznámá"}</span>
											<span className="mx-2">·</span>
											<span>{formatDate(event.created_at)}</span>
										</div>
										{event.user_agent && (
											<div className="text-muted-foreground text-xs">
												{event.user_agent}
											</div>
										)}
									</div>
								</div>
							))}

							{events.length === 0 && (
								<p className="py-4 text-center text-muted-foreground text-sm">
									Žádné bezpečnostní události
								</p>
							)}
						</CardContent>
					</Card>
				</div>
			</Dashboard>
		</>
	);
}
